var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e5ee01cffb15811297a0ae17fc73c5510021af74"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-headlinker@martinratinaud"]={id:"e5ee01cffb15811297a0ae17fc73c5510021af74"};
      